import React, { useState } from "react";
import { Box, Typography, TextField, Button, Alert } from "@mui/material";
import CustomInputSelect from "../../FormFields/CustomSelect/CustomInputSelect";
import { cancelReasons } from "../housekeeping.config";
import { updateScheduleJob } from "../../../api/services/scheduling";
import { useSnackbar } from "notistack";
import { useQueryClient } from "react-query";
import { QK } from "../../../base/qk";

const CancelJobContent = ({ jobId, handleClose, status }) => {
  const [reason, setReason] = useState("");
  const [notes, setNotes] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const queryClient = useQueryClient();

  const isDisabled = status === "Completed" || status === "Cancelled";

  const handleConfirm = async (type, pay_career = false) => {
    if (!reason) {
      enqueueSnackbar("Please select a cancellation reason", {
        variant: "warning",
      });
      return;
    }
    const data = {
      cancelled_reason: reason,
      cancelled_notes: notes,
      cancelled_charge: type,
      pay_career: pay_career,
      status: 6,
    };
    const response = await updateScheduleJob(jobId, data);
    if (response.status === 200) {
      enqueueSnackbar("Job cancelled successfully", { variant: "success" });
      queryClient.invalidateQueries([QK.notStartedJobs]);
      handleClose();
    }
  };

  return (
    <Box sx={{ p: 1 }}>
      {isDisabled && (
        <Alert severity="info" sx={{ mb: 2 }}>
          This visit is already <strong>{status}</strong>. Cancellation is not allowed.
        </Alert>
      )}

      <Typography variant="subtitle1" fontWeight="bold" color="error" mb={2}>
        Confirm Cancellation
      </Typography>

      <CustomInputSelect
        label="Cancellation Reason"
        selectedValue={reason}
        onChange={(e) => setReason(e.target.value)}
        options={cancelReasons}
        disabled={isDisabled}
      />

      <TextField
        label="Cancellation notes"
        multiline
        rows={3}
        fullWidth
        margin="normal"
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        disabled={isDisabled}
      />

      <Box mt={3} display="flex" flexDirection="column" gap={1.5}>
        <Box display="flex" gap={2}>
          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={() => handleConfirm(true, true)}
            sx={{ textTransform: "none" }}
            disabled={isDisabled}
          >
            Cancel – Charge & Pay Carer
          </Button>
          <Button
            fullWidth
            variant="contained"
            color="error"
            onClick={() => handleConfirm(true, false)}
            sx={{ textTransform: "none" }}
            disabled={isDisabled}
          >
            Cancel – Charge Only (DPC)
          </Button>
        </Box>
        
        <Button
          fullWidth
          variant="outlined"
          color="error"
          onClick={() => handleConfirm(false)}
          sx={{ textTransform: "none" }}
          disabled={isDisabled}
        >
          Cancel – No Charge
        </Button>
      </Box>
    </Box>
  );
};

export default CancelJobContent;